module.exports = __webpack_public_path__ + "img/download-fast.07c0db29.webp";